import Vue from "vue"
import store from '@/store'
import VueXI18n from 'vuex-i18n'

Vue.use(VueXI18n.plugin, store)

const messages = {}
const requireContext = require.context('@/assets/locales', true, /.*\.js$/)

requireContext.keys().forEach(file => {
    const lang = file.match(/[a-z]+/)
    const mod = file.replace(/^.+\/|\.js/g, '')
    const trans = {}
    trans[mod.toUpperCase()] = requireContext(file).default
    messages[lang] = Object.assign({}, messages[lang], trans)
})

// @TODO: Set language later if changeable ...
Vue.i18n.set('en')

Object.keys(messages).forEach(locale => {
    Vue.i18n.add(locale, messages[locale])
})



// WEBPACK FOOTER //
// ./src/plugins/locales.js